module.exports = __webpack_public_path__ + "assets/fonts/0b027eb46035d6a71a34e592f05bb640.woff2";